<template>
  <transition name="mobile-menu-fade">
    <div v-if="open" class="fixed inset-0 z-40 bg-white/95 backdrop-blur-md border-b border-gray-200 md:hidden">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Header -->
        <div class="flex items-center justify-between py-4 border-b border-gray-200">
          <router-link to="/" class="flex items-center gap-2" @click="$emit('close')">
            <img :src="entegyLogo" alt="Entegy" class="h-10" />
          </router-link>
          <button type="button"
            class="p-2 rounded-full text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
            aria-label="Close menu" @click="$emit('close')">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Links -->
        <nav class="py-4 space-y-6 overflow-y-auto max-h-[calc(100vh-4rem)]">
          <div class="space-y-2">
            <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Platform
            </h3>
            <div class="grid grid-cols-1 gap-1">
              <router-link v-for="item in platformItems" :key="item.to" :to="item.to"
                class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                @click="$emit('close')">
                <span>{{ item.label }}</span>
                <span class="text-xs text-gray-400">
                  →
                </span>
              </router-link>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <router-link v-for="item in platformFeatures" :key="item.link" :to="item.link"
                class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                @click="$emit('close')">
                <span>{{ item.name }}</span>
                
              </router-link>
              </div>
          </div>

          <div class="space-y-3">
            <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Solutions
            </h3>
            <div v-for="section in solutionsMenu" :key="section.heading" class="space-y-1 pl-1 border-l-2 border-primary-100">
              <div class="text-xs font-semibold text-gray-600 px-2 pb-1">
                {{ section.heading }}
              </div>
              <router-link
                v-for="link in section.links"
                :key="link.to"
                :to="link.to"
                class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                @click="$emit('close')"
              >
                <span>{{ link.label }}</span>
                <span class="text-xs text-gray-400">→</span>
              </router-link>
            </div>
          </div>

          <div class="space-y-2">
            <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Resources
            </h3>
            <div class="grid grid-cols-1 gap-1">
              <template v-for="item in resourcesMenu" :key="item.label">
                <a
                  v-if="item.external"
                  :href="item.href"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                  @click="$emit('close')"
                >
                  <span>{{ item.label }}</span>
                  <span class="text-xs text-gray-400">↗</span>
                </a>
                <router-link
                  v-else
                  :to="item.to"
                  class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                  @click="$emit('close')"
                >
                  <span>{{ item.label }}</span>
                  <span class="text-xs text-gray-400">→</span>
                </router-link>
              </template>
            </div>
          </div>

          <div class="space-y-2">
            <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Partners
            </h3>
            <div class="grid grid-cols-1 gap-1">
              <router-link v-for="item in partnerItems" :key="item.to" :to="item.to"
                class="flex items-center justify-between px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
                @click="$emit('close')">
                <span>{{ item.label }}</span>
                <span class="text-xs text-gray-400">
                  →
                </span>
              </router-link>
            </div>
          </div>

          <div class="space-y-1">
            <router-link v-for="item in simpleItems" :key="item.to" :to="item.to"
              class="block px-2 py-2 rounded-lg text-sm font-medium text-gray-800 hover:bg-gray-50"
              @click="$emit('close')">
              {{ item.label }}
            </router-link>
          </div>
        </nav>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import entegyLogo from '@/images/entegy-logo.svg'

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  }
})

import { platformFeatures } from '../router/features'
import { solutionsMenu, resourcesMenu } from '../data/navSolutionsAndResources.js'

defineEmits(['close'])

const platformItems = computed(() => [
  { label: 'Overview', to: '/overview' },  
])

const partnerItems = computed(() => [
  { label: 'Find a Partner', to: '/find-a-partner' },
  { label: 'Become a Partner', to: '/become-a-partner' }
])

const simpleItems = computed(() => [
  /*{ label: 'Pricing', to: '/pricing' },*/
  { label: 'Contact', to: '/contact' }
])
</script>

<style scoped>
.mobile-menu-fade-enter-active,
.mobile-menu-fade-leave-active {
  transition: opacity 0.2s ease;
}

.mobile-menu-fade-enter-from,
.mobile-menu-fade-leave-to {
  opacity: 0;
}
</style>
